import { b, a } from './chunk-FUQLNXR2.mjs';
import { jsx } from 'react/jsx-runtime';

var c=t=>jsx("svg",b(a({xmlns:"http://www.w3.org/2000/svg",height:"16",width:"14",viewBox:"0 0 448 512",fill:"currentColor"},t),{children:jsx("path",{d:"M248 72c0-13.3-10.7-24-24-24s-24 10.7-24 24V232H40c-13.3 0-24 10.7-24 24s10.7 24 24 24H200V440c0 13.3 10.7 24 24 24s24-10.7 24-24V280H408c13.3 0 24-10.7 24-24s-10.7-24-24-24H248V72z"})})),l=c;

export { l as a };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-UJK6ZACO.mjs.map